import { IMeetingBusy } from "../models/response/meeting/IMeetingBusy";
import { apiClient } from "./apiClient";

export const meetingBusyApi = {
    insert: (payload: IMeetingBusy) => apiClient.post('meeting-teacher-busy', payload),
    update: (payload: IMeetingBusy) => apiClient.put('meeting-teacher-busy', payload),
    select: (payload: string) => apiClient.get("meeting-teacher-busy/nam-hoc/" + payload),
    selectByGv: (payload: string) => apiClient.get("meeting-teacher-busy/gv/nam-hoc/" + payload),
    detail: (id: number) => apiClient.get("meeting-teacher-busy/" + id.toString()),
    delete: (id: number) => apiClient.delete("meeting-teacher-busy/" + id.toString()),
}